module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.shown
    }
  }, [_c('header', {
    slot: "header"
  }, [_c('div', {
    staticClass: "plekan-modal-title"
  }, [_vm._v("File Upload")])]), _vm._v(" "), _c('div', {
    staticClass: "plekan-modal-color-body plekan-clearfix",
    slot: "body"
  }, [_c('file-upload', {
    attrs: {
      "clean": _vm.shown,
      "types": _vm.$allowedFileTypes,
      "fileChange": _vm.fileChange
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "plekan-clearfix",
    slot: "footer"
  }, [_c('button', {
    staticClass: "plekan-footer-button",
    attrs: {
      "disabled": !_vm.file
    },
    on: {
      "click": _vm.onFileUpload
    }
  }, [_vm._v("Upload")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edd3dd78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fileUploadModal.vue
// module id = 121
// module chunks = 0